import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px 0px 20px 0px;
  min-height: 56px;
  padding: 0px 10px;
  background-color: #ffffff;
  border-radius: 4px;

  border: ${({ errorProps }) =>
      !errorProps ? "0.5px solid #4D4C4D99;" : "0.5px solid #4672C5;"};

  :hover {
    transition: border 0.4s;
  }

  > div {
    flex: 1;
    position: relative;

    small {
      font-size: 12px;
      font-family: "Cera Pro Regular", sans-serif;
      flex: 1;
      color: #fff;
      padding-top: 1px;
      padding-bottom: 0;
      padding-left: 3px;
      padding-right: 3px;
      z-index: 10;
      margin-left: -27px;
      top: calc(50% - 36px);
      background-color: #e60023;
      position: absolute;
    }

    > input {
      flex: 1;
      border: 0;
      height: 40px;
      background-color: #ffffff;
      color: #031d3d;
      font-family: "Cera Pro Regular", sans-serif;
      font-size: 16px;
      letter-spacing: 1px;
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;
      padding-left: 6px;
    }

    input::placeholder {
      font-family: "Cera Pro Regular", sans-serif;
      letter-spacing: 0;
    }

    input:-ms-input-placeholder {
      font-family: "Cera Pro Regular", sans-serif;
      letter-spacing: 0;
    }

    input::-ms-input-placeholder {
      font-family: "Cera Pro Regular", sans-serif;
      letter-spacing: 0;
    }
  }
`;
